import core from '~/core/scripts';
import '../styles/index.styl';
import React from 'react';
import ReactDOM from 'react-dom';
import YouDrawItWidget from '~/core/scripts/widgets/YouDrawItWidget';


if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();

// this is just for development purposes -> if we are looking at a layout-sample,
// we check if there is a corresponding js file
if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!../index.html');

  if (location.pathname.includes('.html')) {
    const fileToLoad = location.pathname.replace('.html', '.js');
    try {
      require(`../layout-samples${fileToLoad}`);
    } catch(e) {
      console.log(e);
      console.log(`[Starterkit] no file found ${fileToLoad}`);
    }
  }
}

const ydiContainer2 = document.getElementById('youdrawit2');
if (ydiContainer2) {
  ReactDOM.render((
    <YouDrawItWidget
      chartId="einjahrgroko"
      dataVisibleIndex={5}
      data={[
        { x: 1, y: 52 },
        { x: 2, y: 52 },
        { x: 3, y: 51 },
        { x: 4, y: 51 },
        { x: 5, y: 52 },
        { x: 6, y: 50 },
        { x: 7, y: 52 },
        { x: 8, y: 51 },
        { x: 9, y: 50 },
        { x: 10, y: 52 },
        { x: 11, y: 51 },
        { x: 12, y: 50 },
        { x: 13, y: 52 },
        { x: 14, y: 49 },
        { x: 15, y: 50 },
        { x: 16, y: 49 },
        { x: 17, y: 48 },
        { x: 18, y: 47 },
        { x: 19, y: 49 },
        { x: 20, y: 48 },
        { x: 21, y: 48 },
        { x: 22, y: 49 },
        { x: 23, y: 49 },
        { x: 24, y: 47 },
        { x: 25, y: 47 },
        { x: 26, y: 47 },
        { x: 27, y: 48 },
        { x: 28, y: 46 },
        { x: 29, y: 44 },
        { x: 30, y: 43 },
        { x: 31, y: 42 },
        { x: 32, y: 43 },
        { x: 33, y: 40 },
        { x: 34, y: 39 },
        { x: 35, y: 40 },
        { x: 36, y: 40 },
        { x: 37, y: 41 },
        { x: 38, y: 42 },
        { x: 39, y: 43 },
        { x: 40, y: 46 },
        { x: 41, y: 45 },
        { x: 42, y: 45 },
        { x: 43, y: 45 },
        { x: 44, y: 45 },
        { x: 45, y: 45 },
        { x: 46, y: 46 },
        { x: 47, y: 46 },
        { x: 48, y: 48 },
        { x: 49, y: 46 },
        { x: 50, y: 48 },
        { x: 51, y: 47 },
        { x: 52, y: 47 }
      ]}
      xAxis={[
        { value: 1, label: 'März 2018' },
        { value: 8, label: 'Mai' },
        { value: 17, label: 'Juli' },
        { value: 26, label: 'Sep.' },
        { value: 35, label: 'Nov.' },
        { value: 43, label: 'Jan. 2019' },
        { value: 52, label: 'März' }
      ]}
      yAxis={[
        { value: 30, label: '30 %' },
        { value: 35, label: '35 %' },
        { value: 40, label: '40 %' },
        { value: 45, label: '45 %' },
        { value: 50, label: '50 %' },
        { value: 55, label: '55 %' },
        { value: 60, label: '60 %' }
      ]}
      linecolor="#8D76E0"
      usercolor="#FFA600"
      gapcolor="#FFFCB4"
      servercolor="#A3A3A3"
      showYAxis={true}
      yAxisUnit={null}
      margin={{top: 0, right: 15, bottom: 0, left: 15}}
      shareTitle="Zustimmung zur Groko"
      ratio={{desktop: .6,  mobile: 1 }}
      onCompleted={() => console.log('completed!')}
      showLockButton={false}
    />
  ), ydiContainer2);
}

